import React, { Component, ReactNode } from 'react';
import { CustomFilterCategorical, CustomFilterField, CustomFilterFields } from '../../../domain/ui/FilterDomains';
import Icon from 'icons/Icon';
import { OverlayPanel } from 'primereact/overlaypanel';
import CustomFilterCategoricalEditorComponent from './CustomFilterCategoricalEditorComponent';
import CustomDismissible from '../CustomDismissible';

class CustomFilterCategoricalComponent extends Component<Props> {
  private overlayPanel: OverlayPanel | null = null;

  public render(): ReactNode {
    const { field, id, onChange, fields, onRemove, onToggle } = this.props;
    const label = fields
      .find((f) => f.key === field.field)
      ?.items?.find((item) => item?.key == (field.search.value as CustomFilterCategorical)?.values[0])?.label;
    return (
      <CustomDismissible id={id} onDismiss={() => this.overlayPanel?.hide()}>
        <div id={id}>
          <OverlayPanel appendTo='self' ref={(r) => (this.overlayPanel = r)}>
            <div>
              <CustomFilterCategoricalEditorComponent fields={fields} field={field} onChange={onChange} />
              <div className={'flex px-2 py-3 bg-main-gray w-full items-center justify-end'}>
                <button
                  onClick={this.applyFilter}
                  className={'flex items-center justify-center text-sm cursor-pointer w-full h-9 rounded bg-f-purple text-white'}
                >
                  Apply
                </button>
              </div>
            </div>
          </OverlayPanel>
          <div
            className={`inline-flex shrink-0 items-center h-[32px] cursor-pointer border-[1px]  group bg-[#458EF714] rounded-[4px] box-border text-[#458EF7] border-[#458EF7] ${field.enabled ? '' : 'opacity-40'}`}
          >
            <div
              className='flex justify-center items-center w-full gap-x-1 z-10 px-2 '
              id={`filter-toggle-${id}`}
              onClick={(e) => {
                this.overlayPanel?.toggle(e, e.currentTarget);
              }}
            >
              <p className={'flex items-center shrink-0 font-semibold'}>{field.label}</p>
              <p className={'flex items-center shrink-0'}>:</p>
              <p className={'flex items-center shrink-0'}>{label}</p>
              {((field.search.value as CustomFilterCategorical).values?.length ?? 0) > 1 && (
                <p className={'flex items-center justify-center shrink-0 h-5 w-auto min-w-[20px] bg-[#458EF7] rounded-[50px] text-2xs text-white'}>
                  +{(field.search.value as CustomFilterCategorical).values.length - 1}
                </p>
              )}
            </div>
            <div className={'flex cursor-pointer shrink-0 '}>
              <Icon size={20} onClick={onToggle} className={'opacity-80! hover:opacity-100'} icon={field.enabled ? 'visibility' : 'visibility_off'} />
            </div>
            <div className={'flex cursor-pointer shrink-0'}>
              <Icon size={20} onClick={onRemove} className={'opacity-80 hover:opacity-100'} icon={'close'} />
            </div>
          </div>
        </div>
      </CustomDismissible>
    );
  }

  private applyFilter = () => {
    const { onApply } = this.props;
    onApply();
    this.overlayPanel?.hide();
  };
}

interface Props {
  id: string;
  field: CustomFilterField;
  onChange: () => void;
  fields: CustomFilterFields[];
  onApply: () => void;
  onRemove: () => void;
  onToggle: () => void;
}

export default CustomFilterCategoricalComponent;
